<template>
  <AppButtonExport
    :loading="loading"
    @export-csv="openExportCsv()"
    @export-pdf="openExportPdf()"
    @export-xlsx="openExportExcel()"
  />
  <Dialog
    header="Relatório de bovinos"
    style="min-width: 300px; max-width: 750px"
    :modal="true"
    v-model:visible="visible"
  >
    <div class="p-grid">
      <div class="p-col-12 p-mb-2">
        Selecione abaixo as colunas que estarão presentes no relátorio de
        bovinos.
      </div>
      <div class="p-col-6 p-sm-2">
        <div class="p-field-checkbox">
          <Checkbox
            name="earring"
            :modelValue="true"
            :binary="true"
            :disabled="true"
          />
          <label for="earring"> Brinco </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="type"
            :modelValue="true"
            :binary="true"
            :disabled="true"
          />
          <label for="type"> Tipo </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="breed" v-model="columns.breed" :binary="true" />
          <label for="breed"> Raça </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="weight" v-model="columns.weight" :binary="true" />
          <label for="weight"> Peso </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-3">
        <div class="p-field-checkbox">
          <Checkbox
            name="birthDate"
            v-model="columns.birthDate"
            :binary="true"
          />
          <label for="birthDate"> Data de Nascimento </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="age" v-model="columns.age" :binary="true" />
          <label for="age"> Idade </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="bovineRoot"
            v-model="columns.bovineRoot"
            :binary="true"
          />
          <label for="bovineRoot"> Matriz </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="status" v-model="columns.status" :binary="true" />
          <label for="status"> Status </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-2">
        <div class="p-field-checkbox">
          <Checkbox name="bullType" v-model="columns.bullType" :binary="true" />
          <label for="bullType"> Touro </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="color" v-model="columns.color" :binary="true" />
          <label for="color"> Cor </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="farm" v-model="columns.farm" :binary="true" />
          <label for="farm"> Fazenda </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="farmLot" v-model="columns.farmLot" :binary="true" />
          <label for="farmLot"> Lote/Piquete </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-3">
        <div class="p-field-checkbox">
          <Checkbox name="owner" v-model="columns.owner" :binary="true" />
          <label for="owner"> Proprietário </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="childBirth"
            v-model="columns.childBirth"
            :binary="true"
          />
          <label for="childBirth"> Previsão de Parto </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="tags" v-model="columns.tags" :binary="true" />
          <label for="tags"> Etiquetas </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="observation"
            v-model="columns.observation"
            :binary="true"
          />
          <label for="observation"> Observação </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-2">
        <div class="p-field-checkbox">
          <Checkbox name="buyValue" v-model="columns.buyValue" :binary="true" />
          <label for="buyValue"> Valor de compra </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="calves" v-model="columns.calves" :binary="true" />
          <label for="calves"> Crias </label>
        </div>
      </div>
      <div class="p-col-12" v-if="fileType === 'pdf'">
        <p>Por último, selecione a orientação do arquivo PDF.</p>
      </div>
    </div>
    <div class="p-grid p-jc-end p-mt-3">
      <template v-if="fileType === 'pdf'">
        <div class="p-col-fixed" style="padding-bottom: 0">
          <AutocompleteApi
            v-model:value="template"
            :search="fetchReportTemplate"
            :placeholder="'Modelo'"
          ></AutocompleteApi>
        </div>
        <div class="p-col-fixed" style="padding-bottom: 0">
          <SplitButton
            label="Paisagem"
            @click="exportBovines('pdf-landscape')"
            :model="items"
          ></SplitButton>
        </div>
      </template>
      <template v-if="fileType === 'csv'">
        <div class="p-col-fixed" style="padding-bottom: 0">
          <AppButton label="Ok" @click="exportBovines('csv')"></AppButton>
        </div>
      </template>
      <template v-if="fileType === 'xlsx'">
        <div class="p-col-fixed" style="padding-bottom: 0">
          <AppButton label="Ok" @click="exportBovines('xlsx')"></AppButton>
        </div>
      </template>
    </div>
  </Dialog>
</template>

<script>
import AutocompleteApi from '../../../components/AutocompleteApi.vue';
import { BovineApi, ReportTemplateApi } from '../../../services/api';

const getDefaultColumns = () => ({
  breed: true,
  weight: true,
  birthDate: true,
  age: true,
  bovineRoot: false,
  status: true,
  bullType: false,
  color: false,
  farm: true,
  farmLot: true,
  owner: false,
  childBirth: false,
  tags: false,
  observation: false,
  buyValue: false,
  calves: false,
});

export default {
  name: 'BovineExport',
  props: {
    query: Object,
  },
  components: {
    AutocompleteApi,
  },
  data() {
    return {
      loading: false,
      visible: false,
      template: null,
      fileType: null,
      items: [
        {
          label: 'Retrato',
          command: () => {
            this.exportBovines('pdf-portrait');
          },
        },
      ],
      columns: getDefaultColumns(),
    };
  },
  methods: {
    fetchReportTemplate: ReportTemplateApi.fetch,
    openExportPdf() {
      this.columns = getDefaultColumns();
      this.fileType = 'pdf';
      this.visible = true;
    },
    openExportCsv() {
      this.columns = getDefaultColumns();
      this.fileType = 'csv';
      this.visible = true;
    },
    openExportExcel() {
      this.columns = getDefaultColumns();
      this.fileType = 'xlsx';
      this.visible = true;
    },
    async exportBovines(format) {
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        this.visible = false;
        const timestamp = this.$dayjs().format('DD-MM-YYYY HH-mm');
        const extension = format.includes('pdf') ? 'pdf' : format;
        const filename = `Relatorio de Bovinos - ${timestamp}.${extension}`;
        const columns = Object.keys(this.columns).reduce((final, key) => {
          if (this.columns[key]) {
            final.push(key);
          }
          return final;
        }, []);
        const exportQuery = {
          ...this.query,
          columns: columns.join(','),
        };
        const data = await BovineApi.export(
          exportQuery,
          format,
          this.template?.id
        );
        this.$downloadFile(filename, data);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>
